import { createRequest } from 'ducks/helpers';
import constants from './constants';

export const setStatisticState = createRequest(constants.mainLayout + '_STATISTIC');
export const setAdminTabsState = createRequest(constants.mainLayout + '_ADMIN_TABS');
export const setChipsStripName = createRequest(constants.mainLayout + '_CHIPS_STRIP_NAME');
export const setHiddenChips = createRequest(constants.mainLayout + '_SET_HIDDEN_CHIPS');

export const toggleControls = createRequest(constants.mainLayout + '_TOGGLE_CONTROLS');
